import angular from 'angular';
import { HistoricoUploadController } from './historico-upload.controller';

export class HistoricoUploadComponent implements angular.IComponentOptions {
    static selector = 'historicoUploadComponent';
    static controller = HistoricoUploadController;
    static template = require('!!html-loader!./historico-upload.html');
    static bindings = {
        opened: '<',
        items: '<',
        loading: '<',
        loadError: '<',
        subtitle: '<',
        badgeLabel: '<',
        badgeClass: '<',
        onClose: '&?',
    };
}
